import { render, staticRenderFns } from "./Ganjalf.vue?vue&type=template&id=dd77eb72"
import script from "./Ganjalf.vue?vue&type=script&lang=js"
export * from "./Ganjalf.vue?vue&type=script&lang=js"
import style0 from "./Ganjalf.vue?vue&type=style&index=0&id=dd77eb72&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports